import {
	SET_VEHICLE_CONFIGURATION,
	SET_YEAR,
	SET_MAKE,
	SET_MODEL,
	SET_IMAGE,
	SET_BODYSTYLE,
	SET_PRICE,
	SET_OPTIONS,
	SET_CAB,
	SET_DRIVETRAIN,
	SET_PAINT,
	SET_INTERIOR,
	SET_PACKAGES,
	SET_PACKAGES_SELECTIONS,
	SET_TRIM,
	SET_TRIM_ID
} from './types';

export function setVehicleConfiguration(config) {
	return {
		type: SET_VEHICLE_CONFIGURATION,
		payload: config
	};
}

export function setYear(year) {
	return {
		type: SET_YEAR,
		payload: year
	};
}

export function setMake(make) {
	return {
		type: SET_MAKE,
		payload: make
	};
}

export function setModel(model) {
	return {
		type: SET_MODEL,
		payload: model
	};
}

export function setImage(image) {
	return {
		type: SET_IMAGE,
		payload: image
	};
}

export function setBodyStyle(bodyStyle) {
	return {
		type: SET_BODYSTYLE,
		payload: bodyStyle
	};
}

export function setPrice(price) {
	return {
		type: SET_PRICE,
		payload: price
	};
}

export function setOptions(options) {
	return {
		type: SET_OPTIONS,
		payload: options
	};
}

export function setDrivetrain(drivetrain) {
	return {
		type: SET_DRIVETRAIN,
		payload: drivetrain
	};
}

export function setCab(cab) {
	return {
		type: SET_CAB,
		payload: cab
	};
}

export function setTrim(trimName) {
	return {
		type: SET_TRIM,
		payload: trimName
	};
}

export function setTrimId(trimId) {
	return {
		type: SET_TRIM_ID,
		payload: trimId
	};
}

export function setPaint(paint) {
	return {
		type: SET_PAINT,
		payload: paint
	};
}

export function setInterior(interior) {
	return {
		type: SET_INTERIOR,
		payload: interior
	};
}

export function setPackages(packages) {
	return {
		type: SET_PACKAGES,
		payload: packages
	};
}

export function setPackagesSelections(selections) {
	return {
		type: SET_PACKAGES_SELECTIONS,
		payload: selections
	};
}
